import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FaqService } from '../../../services/faq.service';
import { IFaqFileSystemItemDto } from '../../../interfaces/Faq/ifaq-dto';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-faq-upload',
  templateUrl: './faq-upload.component.html',
  styleUrls: ['./faq-upload.component.css']
})
export class FaqUploadComponent implements OnInit {
  @Output() onUrlCopied = new EventEmitter<string>();

  items: IFaqFileSystemItemDto[] = [];
  currentDir: string = "";
  loading: boolean = false;
  uploading: boolean = false;

  constructor(private faqService: FaqService) { }

  ngOnInit(): void {
    this.loadFiles();
  }

  loadFiles() {
    this.loading = true;
    this.faqService.listFiles(this.currentDir).subscribe({
      next: (items) => {
        this.items = items;
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      }
    });
  }

  onDirClick(item: IFaqFileSystemItemDto) {
    this.currentDir = item.relativePath;
    this.loadFiles();
  }

  goBack() {
    if (this.currentDir) {
      const parts = this.currentDir.split('/');
      parts.pop();
      this.currentDir = parts.join('/');
      this.loadFiles();
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.uploading = true;
      this.faqService.uploadFile(file, this.currentDir).subscribe({
        next: (res) => {
          this.uploading = false;
          this.loadFiles();
        },
        error: (err) => {
          console.error(err);
          this.uploading = false;
          alert('Upload failed: ' + err.message);
        }
      });
    }
  }

  copyUrl(item: IFaqFileSystemItemDto) {
    const urlWithCacheBuster = `${item.publicUrl}`;
    navigator.clipboard.writeText(urlWithCacheBuster).then(() => {
      Swal.fire({
        icon: 'success',
        title: 'URL Copied',
        html: `
          <p><strong>${item.name}</strong></p>
          <p>The copied URL can now be pasted into the FAQ link fields.</p>
        `,
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6'
      });
    });
  }

  get breadcrumbs() {
    if (!this.currentDir) return [];
    return this.currentDir.split('/');
  }

  navigateToBreadcrumb(index: number) {
    const parts = this.currentDir.split('/');
    this.currentDir = parts.slice(0, index + 1).join('/');
    this.loadFiles();
  }

  goToRoot() {
    this.currentDir = "";
    this.loadFiles();
  }

  getFileIcon(item: IFaqFileSystemItemDto): string {
    if (item.isDirectory) return 'folder';
    const name = item.name.toLowerCase();
    if (name.endsWith('.pdf')) return 'picture_as_pdf';
    if (name.match(/\.(jpg|jpeg|png|gif)$/)) return 'image';
    return 'insert_drive_file';
  }

  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
